import { useState } from "react";
import { Link } from "react-router-dom";
import { usePlans } from "../hooks/usePlans";
import { Button } from "../components/common/Button";
import { AccountMenu } from "../components/common/AccountMenu";
import { JsonUploadDialog } from "../components/sheets/JsonUploadDialog";
import { formatDateRange } from "../utils/time";

export function PlanListPage() {
  const [uploadOpen, setUploadOpen] = useState(false);
  const { data: plans, isLoading, error } = usePlans();

  return (
    <div className="min-h-full">
      <header
        className="sticky top-0 z-10 bg-white/90 backdrop-blur border-b border-slate-200 px-4 py-3 flex items-center justify-between"
        style={{ paddingTop: "max(0.75rem, env(safe-area-inset-top))" }}
      >
        <h1 className="text-lg font-semibold text-slate-900">여행 계획</h1>
        <div className="flex items-center gap-1">
          <Button onClick={() => setUploadOpen(true)}>JSON 입력</Button>
          <AccountMenu />
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-4 space-y-3">
        {isLoading && (
          <div className="text-center text-slate-500 py-12">불러오는 중…</div>
        )}
        {error && (
          <div className="text-rose-600 text-center py-6">불러오기 실패</div>
        )}
        {plans && plans.length === 0 && (
          <EmptyState onUpload={() => setUploadOpen(true)} />
        )}
        {plans?.map((p) => (
          <Link
            key={p.id}
            to={`/plans/${p.id}`}
            className="block rounded-2xl bg-white border border-slate-200 px-4 py-4 active:bg-slate-50 transition"
          >
            <div className="font-semibold text-slate-900">{p.title}</div>
            <div className="text-sm text-slate-500 mt-1">
              {formatDateRange(p.firstItemUtc, p.lastItemUtc) || "(빈 일정)"}
            </div>
            <div className="text-xs text-slate-400 mt-1">{p.itemCount}개의 일정</div>
          </Link>
        ))}
      </main>

      <JsonUploadDialog open={uploadOpen} onClose={() => setUploadOpen(false)} />
    </div>
  );
}

function EmptyState({ onUpload }: { onUpload: () => void }) {
  return (
    <div className="text-center py-12 px-2 space-y-3">
      <p className="text-slate-700 font-medium">아직 등록된 계획이 없습니다.</p>
      <p className="text-slate-400 text-sm">"JSON 입력"으로 첫 일정을 만들어 보세요.</p>
      <div className="pt-2">
        <Button onClick={onUpload}>JSON 입력</Button>
      </div>
    </div>
  );
}
